import * as ReportActions from '../../actions/dashboard/actions-report';
import { Report } from '../../models/dashboard/report';

export interface State {
  updateRequired: boolean;
  errorMessage: any;
  data: Report;
}

export const initialState: State = {
  updateRequired: true,
  errorMessage: null,
  data: {} as Report
};

/* eslint-disable */
export function reducer(state = initialState, action: ReportActions.ActionList): State {
  switch (action.type) {
    case ReportActions.ActionTypes.Update: {
      return { ...state, updateRequired: true, errorMessage: '' };
    }

    case ReportActions.ActionTypes.Receive: {
      return {
        ...state,
        updateRequired: false,
        data: action.payload.report,
        errorMessage: action.payload.errorMessage
      };
    }

    case ReportActions.ActionTypes.Error: {
      return { ...state };
    }

    default: {
      return state;
    }
  }
}
